import React from "react";
import "../../style/feature.scss";
import useFacility from "../../utils/hooks/useFacility";

export const PaymentLogos: React.FC = () => {
  const facilityIds = useFacility();

  return (
    <React.Fragment>
      <div className="flex-center-center">
        {facilityIds === "1220" || facilityIds === "350" || facilityIds === "1243" || facilityIds === "1241" ? (
          <img className="paymentLogos" src="https://panel.eaktywni.pl/img/7_flagi_Przelewy24.jpg" alt="płatności" />
        ) : (
          <img
            className="paymentLogos"
            src="https://panel.eaktywni.pl/img/Pasek_banki_karty_10_2020_2.png"
            alt="płatności"
          />
        )}
      </div>
    </React.Fragment>
  );
};
